// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1MvmY","cell":"ColumnAccessor_cell__28NO_","firstCellAccent":"ColumnAccessor_firstCellAccent__3OD7r"};